import {Action} from "redux";
import {IAppNotificationMessageActionCreator} from "../action/app_notification_message_action";
import {
    AddAppNotificationRequest,
    HiddenAppNotificationRequest,
} from "../request/app_notification_message_request";

interface IAppNotificationMessageDispatcher {
    add(item: AddAppNotificationRequest): void;
    hidden(item: HiddenAppNotificationRequest): void;
}

class Dispatcher implements IAppNotificationMessageDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IAppNotificationMessageActionCreator) {

    }

    public add = (item: AddAppNotificationRequest): void => {
        this.dispatch(this.actionCreator.requestAddAction(item));
    };

    public hidden = (item: HiddenAppNotificationRequest): void => {
        this.dispatch(this.actionCreator.requestHiddenAction(item));
    };

}

const createAppNotificationMessageDispatcher = (dispatch: (action: Action) => void, actionCreator: IAppNotificationMessageActionCreator): IAppNotificationMessageDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IAppNotificationMessageDispatcher, createAppNotificationMessageDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/app_notification_message_dispatcher.ts